import { css } from '@/styled-system/css';

export const adminBannerStyles = css.raw({
  padding: '150',
  width: '100%',
  opacity: 0.2,
  transition: 'opacity 0.5s ease',
  _hover: {
    opacity: 1,
  },
});
